const SecureBootIcon = ({ width = 24, height = 24, fill = "#fff" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L4 5.5V11C4 16.55 7.79 21.74 12 23C16.21 21.74 20 16.55 20 11V5.5L12 2Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 12.5L11 14L14.5 10.5"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SecureBootIcon;
